export default (() => {
    const preFooter = document.querySelector('.pre-footer')
    if(preFooter) {
        const backToTop = preFooter.querySelector('[data-back-to-top]')
    
        backToTop && backToTop.addEventListener('click', (e) => {
            e.preventDefault()
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        })
    }
})()


// WEBPACK FOOTER //
// ./scripts/layout/pre-footer.js